const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const LoadingCircle = require("../../core/view/LoadingCircle");
const styles = require("./styles/BlankEngine.css");

module.exports = createReactClass({
	displayName: "BlankEngine",

	propTypes: {
		isInEngineComp: PT.bool,
		withLoading: PT.bool, //Adds a small loading circle to the center of the white area
		className: PT.string,
		children: PT.node,
	},

	render: function() {
		const topClasses =
			styles.problemEngine + " " + (this.props.className || "");
		let loading = null;
		if (this.props.withLoading) {
			loading = (
				<div className={styles.engineLoadingContainer}>
					<div className={styles.engineLoadingSizing}>
						<LoadingCircle colorType="transparentGray" />
					</div>
				</div>
			);
		}
		const inner = (
			<div className={styles.engineOuter}>
				<img
					className={styles.engineBg}
					src={global.BASE_URL + "assets/images/elements/playarea-area.svg"}
				/>
				{loading}
				{this.props.children}
			</div>
		);

		if (this.props.isInEngineComp) {
			return inner;
		}
		return (
			<div className={topClasses}>
				<div className={styles.engineArea}>{inner}</div>
			</div>
		);
	},
});
